<template>
  <div id="video-player"
    class="flex center"
    ref="player"
    :class="{ pip: pip, lower: lower }"
    v-show="currentVideo"
    v-on:keyup.esc="updateCurrentVideo(false)"
    tabindex="0">

    <div class="m-auto" v-if="currentVideo">
      <div v-if="pip" class="relative z1 caps fs-s right-align bar mb1">
        <span class="pointer red" @click="closePip()">Close</span>
      </div>
      <video
        @click="expandVideo()"
        @contextmenu.prevent=""
        id="video-player-object"
        class="relative z1"
        :src="videoSrc"
        autoplay
        controls
        controlsList="nodownload" />
    </div>
    <div v-if="currentVideo && !pip">
      <div id="video-player-title" class="fixed z1">
        <span class="xs-hide sm-hide">{{ videoDetails.name }}</span>
        <span class="xs-hide md-hide lg-hide">{{ videoDetails.name | truncate(48) }}</span>
        <span class="sm-hide md-hide lg-hide">{{ videoDetails.name | truncate(32) }}</span>
      </div>
      <div @click="shrinkVideo()" class="hover-red caps top-right pointer z1 fixed xs-hide">Shrink Player</div>
      <div @click="updateCurrentVideo(false)" class="hover-red caps top-left pointer z1 fixed">Close</div>
      <div id="video-bg"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {

  name: 'VideoPlayer',

  data () {
    return {
      pip: false
    }
  },

  computed: {
    ...mapState([
      'currentVideo'
    ]),
    videoDetails () {
      if (this.currentVideo.hasOwnProperty('video')) {
        return JSON.parse(this.currentVideo.video.object)
      } else {
        return this.currentVideo
      }
    },
    videoSrc () {
      let file = this.videoDetails.files.find(file => file.height === 720)

      if (file === undefined) {
        file = this.videoDetails.files.find(file => file.quality === 'hd')
      }

      if (file === undefined) {
        file = this.videoDetails.files.find(file => file.quality === 'sd')
      }

      return file['link']
    },
    lower () {
      return this.$route.meta.pipLower
    }
  },

  // mounted () {
  //   this.$refs.player.$el.addEventListener("keyup", this.videoNav)
  // },

  // destroyed () {
  //   this.$refs.player.$el.removeEventListener("keyup", this.videoNav)
  // },

  methods: {
    ...mapActions([
      'updateCurrentVideo'
    ]),
    videoNav () {
      if (event.key === "Escape") {
        this.updateCurrentVideo(false)
      }
    },
    closePip () {
      this.updateCurrentVideo(false)
      this.pip = false
    },
    shrinkVideo () {
      this.pip = true
      document.getElementById('video-player-object').controls = ""
    },
    expandVideo () {
      this.pip = false
      document.getElementById('video-player-object').controls = "controls"
    }
  },

  watch: {
    '$route' () {
      if (!this.pip) {
        this.updateCurrentVideo(false)
      }
    }
  }
}
</script>

<style lang="css" scoped>
  #video-player {
    color: var(--col-light);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10002;
    transition: all 0.2s ease-out;

    #video-bg {
      pointer-events: none;
      transition: all 0.2s ease-out;
      opacity: 1;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.9);
    }

    video {
      cursor: pointer;
      width: 80vw;
    }

    #video-player-title {
      top: 1em;
      left: 0;
      right: 0;

      span {
        max-width: 60vw;
        display: block;
        margin: 0 auto;
      }
    }

    .top-left {
      top: 1em;
      left: 1em;
    }

    .top-right {
      top: 1em;
      right: 1em;
    }

    &.pip {
      color: var(--black);
      top: initial;
      left: initial;
      width: 12vw;
      right: 2em;
      bottom: 4em;
      z-index: 10001;

      &.lower {
        bottom: 2em;
      }

      &:hover {
        width: 14vw;
      }

      video {
        border: 1px solid var(--col-light);
        width: 100%;
      }
    }
  }
</style>
